export const isPhoneUrl = (url: string) => {
  return url.startsWith('tel:');
};
